module.exports = __webpack_public_path__ + "img/Testlockred.87ed87cd.svg";